import { put, call } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/pieceInfo';
import { get } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getPieceDetails({ payload }) {
  try {
    const report = yield call(get, `/piece/${payload.pieceNumId}`);
    yield put(action.getPieceDetailsSuccess(report));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getPieceDetailsFail());
  }
}
